import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValueSetInt, LastUsedSettingsType, LocalService, TriggeredEvent, KeyValueSet, KeyValues3, FocusInputType, LastUsedKey } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss']
})
export class LanguageSelectionComponent implements OnInit {
  @ViewChild('content_language_selection')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() isShowAll: boolean = false; searchKey = '';
  languages: KeyValueSet[]; isInnerUsage = false;
  sourceLanguages: KeyValues3[];

  elementIds: any; htmlId: string = '';

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, public profileManagementService: ProfileManagementService, private router: Router) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_search_key: 'txt_search_key_' + this.htmlId
    };
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    if (this.isInnerUsage) {
      this.languageManagementService.getLanguagesToDisplay(true).subscribe(result => {
        this.sourceLanguages = result.val;
        this.localService.languagesEquivalent = result.valEqu;
        this.onFilterLanguage();
      });
    } else {
      this.sourceLanguages = this.localService.languages;
      this.onFilterLanguage();
    }
  }

  onFilterLanguage() {
    if (this.sourceLanguages) {
      let currentLanguage = this.localService.getSelectedLanguageId();
      let searchKey = this.searchKey.trim().toLowerCase();
      let items = searchKey != '' ? this.sourceLanguages.filter(x => x.v3.indexOf(searchKey) > -1)
        : this.sourceLanguages;
      this.languages = items.map(function (result) {
        return {
          key: result.key,
          value: result.v2,
          isSelected: currentLanguage == result.key
        } as KeyValueSet;
      });

      this.localService.onFocusNextInput(this.elementIds.txt_search_key, FocusInputType.TextBox);
    }
  }

  onPopupClose() {
    this.onCloseTrigger({ event: TriggeredEvent.Close });
  }

  onSave() {
    if (!this.isInnerUsage && this.localService.selected.user && this.localService.loggedMember) {
      let items: LastUsedKey[] = [];
      items.push({ keyType: LastUsedSettingsType.ApplicationLanguage, value: this.localService.selected.applicationLanguage } as LastUsedKey);
      //items.push({ key: LastUsedSettingsType.LocalLanguage, value: this.localService.selected.applicationLanguage } as LastUsedKey);
      this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
      });
    }
  }

  onSelectionChanged(id) {
    if (this.isInnerUsage) {
      this.onCloseTrigger({ event: TriggeredEvent.Ok, data: id });
    } else {
      if (this.localService.loggedMember) {
        this.localService.selected.applicationLanguage = id;
        this.onSave();
        this.languageManagementService.onLanguageChanged();
      } else {
        if (this.router.url == '' || this.router.url == '/' || this.router.url.indexOf('lang/') > -1) {
          //this.localService.redirectUrl = '';
          this.router.navigate(['/lang', this.localService.getLanguageCode(id)]);
        } else {
          this.localService.selected.applicationLanguage = id;
          this.languageManagementService.onLanguageChanged();
        }
      }
      this.onCloseTrigger({ event: TriggeredEvent.Ok, data: id });
    }
  }
}
